import { render, staticRenderFns } from "./AboutTheWard.vue?vue&type=template&id=a0beebd6&scoped=true&"
import script from "./AboutTheWard.vue?vue&type=script&lang=js&"
export * from "./AboutTheWard.vue?vue&type=script&lang=js&"
import style0 from "./AboutTheWard.vue?vue&type=style&index=0&id=a0beebd6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0beebd6",
  null
  
)

export default component.exports